import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell
} from "@mui/material";
import React from "react";

import {fonts} from '../../../util/Theme'
import InvoiceRow from "./InvoiceTableComponents/InvoiceRow";
/**
 * Table Displaying admin's version of submitted timesheets
 * @component 
 * @category Timesheets
 * @subcategory Submitted Timesheets 
 */
function InvoiceConfirmDisplay(props) {

  const columns = [
    { label: "Resource", accessor: "resource", sortable: true },
    { label: "Client", accessor: "client", sortable: true },
    { label: "Transaction Date", accessor: "txn_date", sortable: true },
    { label: "Due Date", accessor: "due_date", sortable: true },
    { label: "Hours", accessor: "hours", sortable: true},
    { label: "Bill Rate", accessor: "bill_rate", sortable: true},
    { label: "Invoice Amount", accessor: "invoice_amt", sortable: true },
    { label: "Invoice Type", accessor: "invoice_type", sortable: true },
   ];

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              {columns.map(({label,accessor}) => {
                return <TableCell key={accessor} align='center' sx={{ fontSize: fonts.tableSize }} >{label}</TableCell>
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.invoices.length > 0 ? (
              <>
                {props.invoices.map((inv) => {
                  
                  return (

                  <InvoiceRow invoice = {inv} handleConfirm = {props.handleConfirm} handleReject = {props.handleReject} handleEdit = {props.handleEdit}/>
                )})}
              </>
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default InvoiceConfirmDisplay;
